<div class="row page-header">
    <div class="col-12">
        <h1>Blue Stakes Log <small>Track blue stakes tickets by job</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                            [showDuplicate]="false"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Blue Stakes Log'"></grid-export>
                        <a class="align-self-center" href="https://www.bluestakes.org/" target="_blank" rel="noopener noreferrer"
                            >Blue Stakes of Utah 811</a
                        >
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <grid-column-group [grid]="grid"></grid-column-group>
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="25"
                        [itemFormatter]="mainGridItemFormatter"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        (cellEditEnded)="onActiveCellEditEnded(mainGrid, $event)"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Active'"
                            [binding]="'isActive'"
                            [width]="80"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job'"
                            [binding]="'job'"
                            [dataMap]="jobDisplayMap"
                            [width]="260"
                            [minWidth]="180"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Address'" [binding]="'address'" [width]="'*'" [minWidth]="200" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Order'" [binding]="'orderedDate'" [width]="110" [format]="'d'" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Legal'" [binding]="'legalDate'" [width]="110" [format]="'d'" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Update'"
                            [binding]="'ticketUpdateDate'"
                            [width]="110"
                            [format]="'d'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Ticket #'"
                            [binding]="'ticketNumber'"
                            [width]="130"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Time'"
                            [binding]="'requestTime'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Requester'"
                            [binding]="'requesterHrRef'"
                            [dataMap]="vistaUserMap"
                            [width]="160"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Phone #'"
                            [binding]="'phoneNumber'"
                            [width]="130"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Ticket Owner'"
                            [binding]="'ticketOwnerHrRefs'"
                            [minWidth]="200"
                            [width]="'*'"
                            [isReadOnly]="true"
                        >
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Notes'"
                            [binding]="'notes'"
                            [minWidth]="200"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
